export default __webpack_public_path__ + "static/media/1.d1a2aa71.jpg";